/**
 * SuccessCard — post-submit confirmation. Opens bl181-web's ImportBarcodeWizard
 * in a new tab so Brian can verify the batch landed.
 *
 * point (per FORK brief). Kept sparse anyway.
 */

import { ExternalLink, RefreshCw } from 'lucide-react'
import type { ConfirmResult } from '../api'
import { AgentBubble } from './AgentBubble'

interface SuccessCardProps {
  result: ConfirmResult
  onReset: () => void
}

export function SuccessCard({ result, onReset }: SuccessCardProps) {
  return (
    <div className="w-full max-w-xl space-y-4">
      <AgentBubble from="agent">
        Done! Import is live. Want to verify in the portal?
      </AgentBubble>

      {result.message ? (
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-300">
          <div className="font-medium uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Magic Money said
          </div>
          <div className="mt-1">{result.message}</div>
        </div>
      ) : null}

      <div className="flex flex-wrap gap-2">
        <a
          href={result.mmImportUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 rounded-lg bg-outdoor-500 px-4 py-2 text-sm font-medium text-white hover:bg-outdoor-600"
        >
          <ExternalLink className="h-4 w-4" />
          Open in Magic Money
        </a>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
        >
          <RefreshCw className="h-4 w-4" />
          Import another
        </button>
      </div>
    </div>
  )
}
